import { render, staticRenderFns } from "./MentPlan.vue?vue&type=template&id=34700815&scoped=true&"
import script from "./MentPlan.vue?vue&type=script&lang=js&"
export * from "./MentPlan.vue?vue&type=script&lang=js&"
import style0 from "./MentPlan.vue?vue&type=style&index=0&id=34700815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34700815",
  null
  
)

export default component.exports